import {
	DialogRoot,
	DialogPortal,
	DialogOverlay,
	DialogContent,
	DialogTitle,
	DialogDescription,
	DialogClose,
} from "@umahealth/occipital/client";
import { Button, Title, Paragraph } from "@umahealth/occipital"; // Asegúrate de importar tus componentes de la biblioteca correcta
import { ApprovalStatusCard } from "../../cards/ApprovalStatusCard/ApprovalStatusCard";
import { StatusImage } from "../ConfirmationModal/ConfirmationModal";
import { QRCodeSVG } from "qrcode.react";

interface DialogProps {
	children?: React.ReactNode;
	open?: boolean;
	defaultOpen?: boolean;
	onOpenChange?(open: boolean): void;
	modal?: boolean;
}

export function EndCallModalDialogRoot({
	children,
	modal = true,
	...props
}: DialogProps) {
	return (
		<DialogRoot modal={modal} {...props}>
			{children}
		</DialogRoot>
	);
}

export function EndCallModal({
	approved,
	fullname,
	legajo,
	operationId,
	uid,
	companyId,
	baseUrl,
}: {
	approved?: boolean;
	fullname?: string;
	legajo?: string;
	operationId?: number;
	uid?: string;
	companyId?: number;
	baseUrl?: string;
}) {
	return (
		<DialogPortal>
			<DialogOverlay className="z-[100]" />
			<DialogContent className="z-[101] flex items-center flex-col p-8 max-h-[90dvh] overflow-y-auto">
				<StatusImage
					className="my-6"
					status={approved ? "success" : "warning"}
				/>
				<DialogTitle asChild>
					<Title
						hierarchy="h1"
						color="text-primary-800"
						size="text-l"
						weight="font-semibold"
						className="mb-4"
					>
						Nueva revisión finalizada
					</Title>
				</DialogTitle>
				<DialogDescription asChild>
					<Paragraph className="text-center pb-6">
						El operador {approved ? "" : "no"} podra comenzar su
						jornada laboral
					</Paragraph>
				</DialogDescription>
				<ApprovalStatusCard
					className="mb-6"
					fullname={fullname}
					legajo={legajo}
					approval={approved}
				/>
				{uid && companyId && baseUrl && (
					<div className="flex flex-col items-center mb-6 p-4 bg-grey-50 rounded-lg">
						<Paragraph className="text-center mb-3 font-semibold text-grey-700">
							Escanea para ver tu resultado
						</Paragraph>
						<QRCodeSVG
							size={180}
							value={`${baseUrl}/usuarios/${uid}/ultimaOperacion?companyId=${companyId}`}
						/>
					</div>
				)}
				<section
					className="py-4 px-6 w-full"
					aria-label="acciones posibles"
				>
				<DialogClose asChild>
				</DialogClose>
					<DialogClose asChild>
						<Button variant="text" size="full" type="button">
							Cerrar
						</Button>
					</DialogClose>
				</section>
			</DialogContent>
		</DialogPortal>
	);
}
